"use client";
import React, { useState } from "react";
import { DetailCard } from "@/data";
import { useAuth } from "@/hooks";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { BsTrash } from "react-icons/bs";
import { formatStringSlug, renderContentWithLineBreaks } from "@/utils/formatted";
import { useDispatch } from "react-redux";
import { DesCard, TitleCard, NormalStyles, GenreCard } from "@/layouts/styles/ssr.style";
import { BiUser } from "react-icons/bi";
import { definitions } from "@/services/metruyenvl";
import { Popover } from "antd";
import bookAPI from "@/services/book_api";
import bookmarkAPI from "@/services/bookmark_api";
import BookCover from "@/components/book-cover.component";
import ConfirmDeleteModal from "@/components/confirm-delete-modal";

function CardBookReadings({ book, isDelete, reloadData, deleteFunc, chapter }: { book: definitions["do.BookDO"]; chapter?: definitions["do.ChapterDetailRes"]; isDelete?: boolean; reloadData?: any; deleteFunc?: any }) {
    const router = useRouter();
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const redirectPage = () => {
        router.push(`/truyen/${book.slug}`);
    };
    return (
        <div className="flex gap-x-3 w-full justify-between p-2 md:mb-0">
            <ConfirmDeleteModal
                isVisible={isVisible}
                title="Bạn có chắc chắn muốn xoá truyện này không?"
                cancelCallback={() => {
                    setIsVisible(false);
                }}
                confirmCallback={() => {
                    deleteFunc();
                    setIsVisible(false);
                }}
            />
            <div className="object-cover md:w-20 cursor-pointer" onClick={redirectPage}>
                <BookCover src={book.thumbnail as string} alt={book.name as string} size="medium" />
            </div>

            <div className="flex w-full flex-col justify-between">
                <div className="flex justify-between items-center">
                    <TitleCard click={redirectPage}>
                        <Popover content={book.name} placement="top">
                            {book.name}
                        </Popover>
                    </TitleCard>
                    <div className="cursor-pointer">
                        {isDelete && (
                            <BsTrash
                                color="red"
                                size={18}
                                onClick={() => {
                                    setIsVisible(true);
                                }}
                            />
                        )}
                    </div>
                </div>
                <DesCard>
                    <div dangerouslySetInnerHTML={{ __html: renderContentWithLineBreaks(book.description) }}></div>
                </DesCard>
                <div className="flex justify-between items-center mt-2">
                    <div
                        className="flex items-center gap-1 cursor-pointer"
                        onClick={() => {
                            // router.push(`/tac-gia/${book.author_slug}`);
                        }}
                    >
                        <NormalStyles>
                            Đã đọc: {chapter?.chapter_idx ?? 0}/{book?.chapters_count ?? 0}
                        </NormalStyles>
                    </div>
                    <GenreCard
                        click={() => {
                            router.push(`/the-loai/${book.tags?.[0].slug}/${book.tags?.[0].id}`);
                        }}
                    >
                        <Popover content={book.tags?.[0].name ?? "Khác"} placement="top">
                            {book.tags?.[0].name ?? "Khác"}
                        </Popover>
                    </GenreCard>
                </div>
            </div>
        </div>
    );
}

export default CardBookReadings;
